import { createContext } from "react";

export interface UserOptions {
  edit: string;
  create: string;
  delete: string;
}

interface AppContextType {
  userWorkflows: any[],
  workFlowData: any;
  userRole: string[];
  companyType: string;
  accountDetails: any;
  license: string;
  setAccountDetails: (accountDetails: any) => void;
  notify: any;
  toastNotify: (toastNotify: any) => void;
  analysedPage?: any,
  setAnalysedPage?: any;
  pageLimit?: number;
  getDefaultWorkFlow?: any,
  getUsersWorkFlows: any,
  setUserWorkflows: any,
  getAccountDetails: any,
  setActivePage: any,
  activePage: any,
  defaultAbsent: any,
  setDefaultAbsent: any,
  setActiveWorkflow: any,
  activeWorkflow: any,
  setWorkflowProcess: any,
  workflowProcess: any,
  startDate: any,
  endDate: any,
  setStartDate: any,
  setEndDate: any,
  resetDates: any,
  selectedLevel: any,
  setSelectedLevel: any,
  updateDashboardApi: any,
  setUpdateDashboardApi: any,
  selectedTransport: any,
  setSelectedTransport: any
}

export const AppContext = createContext<AppContextType>({
  activePage: 'Dashboard',
  setActivePage: () => { },
  userRole: [""],
  companyType: "",
  userWorkflows: [],
  workFlowData: {},
  accountDetails: null, // Provide an initial value for accountDetails
  license: "", // Provide an initial value for license
  setAccountDetails: () => { }, // Provide an empty function as initial value
  notify: null,
  toastNotify: () => { },
  pageLimit: 1,
  analysedPage: 1,
  setAnalysedPage: () => { },
  getDefaultWorkFlow: () => { },
  getUsersWorkFlows: () => { },
  setUserWorkflows: () => { },
  getAccountDetails: () => { },
  defaultAbsent: () => { },
  setDefaultAbsent: () => { },
  setActiveWorkflow: () => { },
  activeWorkflow: null,
  setWorkflowProcess: () => { },
  workflowProcess: {},
  startDate: null,
  endDate: null,
  setStartDate: () => { },
  setEndDate: () => { },
  resetDates: () => { },
  selectedLevel: null,
  setSelectedLevel: () => { },
  updateDashboardApi: false,
  setUpdateDashboardApi: () => { },
  selectedTransport: null,
  setSelectedTransport: () => { }
});
